import ACTIONS from "./BlocklistActionTypes";

const initialState = {
  getBlocklistListLoading: false,
  getBlocklistListResponse: null,
  postBlocklistLoading: false,
  postBlocklistResponse: null,
  deleteBlocklistLoading: false,
  deleteBlocklistResponse: null,
};

const BlockListListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.GET_BLOCKLIST_REQUEST:
      return {
        ...state,
        getBlocklistListLoading: true,
      };
    case ACTIONS.GET_BLOCKLIST_RESPONSE:
      return {
        ...state,
        getBlocklistListLoading: false,
        getBlocklistListResponse: action.payload.data,
      };
    case ACTIONS.POST_BLOCKLIST_REQUEST:
      return {
        ...state,
        postBlocklistLoading: true,
      };
    case ACTIONS.POST_BLOCKLIST_RESPONSE:
      return {
        ...state,
        postBlocklistLoading: false,
        postBlocklistResponse: action.payload,
      };
    case ACTIONS.POST_BLOCKLIST_RESPONSE_CLEAR:
      return {
        ...state,
        postBlocklistResponse: null,
      };
    case ACTIONS.DELETE_BLOCKLIST_REQUEST:
      return {
        ...state,
        deleteBlocklistLoading: true,
      };
    case ACTIONS.DELETE_BLOCKLIST_RESPONSE:
      return {
        ...state,
        deleteBlocklistLoading: false,
        deleteBlocklistResponse: action.payload,
      };
    case ACTIONS.DELETE_BLOCKLIST_RESPONSE_CLEAR:
      return {
        ...state,
        deleteBlocklistResponse: null,
      };
    default:
      return state;
  }
};

export default BlockListListReducer;
